"use client";

import Image from "next/image";
import Typography from "../new/Common/Typography";
import { useState } from "react";
import useViewType from "@/utils/Hooks/useViewType";
import { StandardLPBonus } from "@/services/types";
interface Props {
  bigText: string;
  smallText: string;
  cards: StandardLPBonus[];
}
export const SectionBonuses = ({
  bigText,
  smallText,
  cards
}: Props) => {
  const isMobile = useViewType();
  const [viewAll, setViewAll] = useState(false);
  const handleClick = (e: any) => {
    setViewAll(!viewAll);
  };
  return <div className="flex flex-col relative gap-4 md:gap-8 px-6 md:px-0 pt-8 pb-[60px] md:py-0" data-sentry-component="SectionBonuses" data-sentry-source-file="SectionBonuses.tsx">
      <div className="flex flex-col gap-5 md:gap-4">
        <Typography variant="Display 5 M | 32 | 120" data-sentry-element="Typography" data-sentry-source-file="SectionBonuses.tsx">
          {bigText}
        </Typography>
        <Typography variant="Body 1 R | 16 | 160" data-sentry-element="Typography" data-sentry-source-file="SectionBonuses.tsx">
          {smallText}
        </Typography>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {cards.slice(0, viewAll ? cards.length : isMobile ? 3 : 6).map((card, index) => <div className="flex flex-col gap-4 p-6 border-[1px] border-[rgba(151,167,166,0.40)] rounded-xl bg-[#FFFAF1]" key={index}>
              <div className="flex items-center gap-2">
                <Image src={"/images/new/tick.svg"} alt={"tick"} height={25} width={25} loading="lazy" />
                <Typography variant="Heading 2 M | 20 | 120" className="text-[#002726]">
                  {card.attributes.title}
                </Typography>
              </div>
              <Typography variant="Body 1 R | 16 | 160" className="text-[#002726]">
                {card.attributes.description}
              </Typography>
            </div>)}
      </div>
      {cards.length > (isMobile ? 3 : 4) && !viewAll && <>
          <div className="absolute bottom-[18px] md:bottom-0 left-0 bg-white w-full md:h-[174px] h-[254px]" style={{
        background: "linear-gradient(183deg, rgba(255, 255, 255, 0.00) 2.24%, #FFF 67.87%)"
      }} />
          <div className="flex items-center gap-2 absolute bottom-[18px] md:bottom-0 self-center cursor-pointer" onClick={handleClick}>
            <Typography variant="Body 1 M | 16 | 120">View more bonuses</Typography>
            <Image src="/images/course-diff/down-arrow.svg" alt="down arrow" width={14} height={10} loading="lazy" />
          </div>
        </>}
      {cards.length > (isMobile ? 3 : 4) && viewAll && <div className="flex items-center gap-2 pt-6 self-center cursor-pointer" onClick={handleClick}>
          <Typography variant="Body 1 M | 16 | 120">View less bonuses</Typography>
          <Image className="rotate-180" src="/images/course-diff/down-arrow.svg" alt="down arrow" width={14} height={10} loading="lazy" />
        </div>}
    </div>;
};
export default SectionBonuses;